<template>
  <div class="wrapper">
    <sidebar />
    <main class="main-container" :class="{ active: showSidebar }">
      <top-nav :connected="connected" />
      <bottom-nav v-if="selectedOrder" />
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import Sidebar from "@/components/Dashboard/Sidebar";
import TopNav from "@/components/Dashboard/TopNav";
import BottomNav from "@/components/Dashboard/BottomNav";
import { connectionTest } from "@/network/rest";
import { mapState, mapGetters } from "vuex";
import { getCurrentUuid, getAccessToken } from "@/helpers/storage";
import {
  populateOrders,
  query,
  populateScheduledOrders,
} from "@/helpers/queries";
import { webSocketEvents } from "@/feathers-client";

export default {
  name: "dashboard",
  components: {
    Sidebar,
    TopNav,
    BottomNav,
  },
  computed: {
    ...mapState(["showSidebar"]),
    ...mapGetters({ selectedOrder: "getSelectedOrder", uuid: "getUuid" }),
    feathers() {
      return this.$FeathersVuex.api;
    },
  },
  data() {
    return {
      connected: true,
    };
  },
  mounted() {
    webSocketEvents("connect", this.keepAlive);
    webSocketEvents("error", this.keepAlive);
  },
  methods: {
    keepAlive() {
      const auxUuid = getCurrentUuid();
      const _query = query();
      const accessToken = getAccessToken();
      const company = _query.company;
      const branch = _query.branch;
      //  const time = 60000;

      if (this.uuid === auxUuid && accessToken && company && branch) {
        connectionTest()
          .then((result) => {
            this.connected = true;

            populateOrders(
              this.feathers,
              accessToken,
              company,
              branch,
              16,
              true
            );

            populateScheduledOrders(
              this.feathers,
              accessToken,
              company,
              branch,
              null,
              true
            );

            //  setTimeout(this.keepAlive, time);
          })
          .catch((e) => {
            console.log("erro ao conectar com o servidor");
            console.log(e);

            this.connected = false;

            //  setTimeout(this.keepAlive, Math.round(time / 3));
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
